import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const Context = React.createContext();

//Medellin
// const center = {
//   lat: 6.230833,
//   lng: -75.590553,
// };

//Bogotá
const center = {
  lat: 4.6592648,
  lng: -74.162618,
};

export const ContextProvider = ({ children }) => {
  const [map, setMap] = useState();
  const [activeMarkerId, setActivemarkerid] = useState();
  const [bounds, setBounds] = useState(0);
  const [dropPoints, setDroppoints] = useState([]);
  const [mapMarkers, setMapmarkers] = useState([]);
  const [lastZoom, setLastZoom] = useState(14);

  const setLastCenter = (newCenter) => {
    window.lastCenter = newCenter;
  };

  useEffect(() => {
    setLastCenter(center);
    setLastZoom(14);
  }, []);

  return (
    <Context.Provider
      value={{
        map,
        setMap,
        activeMarkerId,
        setActivemarkerid,
        bounds,
        setBounds,
        dropPoints,
        setDroppoints,
        mapMarkers,
        setMapmarkers,
        center,
        setLastCenter,
        lastZoom,
        setLastZoom,
      }}
    >
      {children}
    </Context.Provider>
  );
};

ContextProvider.propTypes = {
  children: PropTypes.element,
};
